export default __webpack_public_path__ + "static/media/logo1.e055b6e5.png";